<template>
    <VAppLayout>
        <VContainer>
            <VAppTitle :title="$t('pages.menu.title')">
                <VAppLocale />
            </VAppTitle>
            <a class="menu-category-go-back"
               @click="goBack">
                <IconArrowDown /><span> Go back</span>
            </a>
            <div class="menu-category"
                 :key="comCategory.category_id">
                <div class="menu-category-name">{{ comCategory.name }}</div>
                <p v-if="comCategory.description"
                   class="menu-category-description">
                    {{ comCategory.description }}
                </p>
                <ul>
                    <MenuItem v-for="item in comFilteredItems"
                              :item="item"
                              :key="item.id" />
                </ul>
                <div v-if="comCategory.subcategories">
                    <div v-for="subcategory in comCategory.subcategories"
                         class="menu-subcategory"
                         :key="subcategory.category_id">
                        <p class="menu-subcategory-name">{{ subcategory.name }}</p>
                        <ul>
                            <MenuItem v-for="item in subcategory.items"
                                      :item="item"
                                      :key="item.id" />
                        </ul>
                    </div>
                </div>
            </div>
        </VContainer>
    </VAppLayout>
</template>

<script>
import VAppLayout from "@/layouts/VAppLayout.vue";
import VContainer from "@/components/ui/VContainer.vue";
import VAppTitle from "@/components/ui/VAppTitle.vue";
import VAppLocale from "@/components/ui/VAppLocale.vue";
import MenuItem from "./MenuItem.vue";
import IconArrowDown from "@/components/icons/IconArrowDown.vue";

export default {
    name: "MenuSingle",
    components: {
        VAppLayout,
        VContainer,
        VAppTitle,
        VAppLocale,
        MenuItem,
        IconArrowDown,
    },
    props: {
        id: null,
    },
    data() {
        return {
        };
    },
    created() {
        this.$store.dispatch('menuStore/GET_FULL_MENU');
    },
    computed: {
        comCategory() {
            const popular = this.$store.getters['menuStore/getPopular'];
            if (popular && popular.id === this.id) {
                return popular;
            }
            const menu = this.$store.getters['menuStore/getMenu'] || [];
            const category = menu.find(c => c.id == this.id);

            return category || {};
        },
        comFilteredItems() {
            let res = this.comCategory.items;

            if (this.comCategory.subcategories && this.comCategory.subcategories.length !== 0) {
                const subItems = this.comCategory.subcategories.reduce((arr, val) => {
                    return arr.concat(val.items);
                }, []);

                res = this.comCategory.items.filter(item => {
                    return !subItems.some(subItem => subItem.category_id === item.category_id);
                });
            }

            return res;
        }
    },
    methods: {
        goBack() {
            this.$router.back();
        }
    }
};
</script>

<style lang="scss" scoped>
@import "/src/scss/assets/variables";

ul {
    list-style-type: none;
    padding: 0;
    margin: 0;

}

.menu-category {
    padding-top: 16px;
    scroll-margin-top: 50px;
}

.menu-category-name {
    margin: 10px 0;

    font-weight: 590;
    font-size: 22px;
    line-height: 100%;

    color: black;
}

.menu-subcategory-name {
    margin: 20px 0 10px;

    font-weight: 510;
    font-size: 14px;
    line-height: 100%;

    color: black;
}

.menu-category-description {
    margin: 10px 0;
    padding: 12px;

    font-family: Poppins;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    text-align: center;

    border: 1px solid #EDEDED;
    border-radius: 12px;

    color: black;
    background-color: $color_white_titan;
}


.menu-category-go-back {
    display: flex;
    align-items: center;

    font-size: 16px;
    line-height: 100%;

    color: #6466ED;

    svg {
        transform: rotate(90deg);
        margin-bottom: 2px;
    }
}
</style>